import React, { useMemo, useState } from 'react';
import './Style/AllUsers.css';
import TopNavbar from '../home/TopNavbar';
import Loading from '../home/Loading';
import UseAppItemsUse from './UseAppItemsUse';
import useUsersData from '../Auth/AllUsers';
import UsePayments from './UsePayments';

const AppItemsUse = () => {
  const { appitemsuse, loading } = UseAppItemsUse();
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const { users } = useUsersData();
  const { allPayments } = UsePayments();


  // State to track which row is clicked/expanded
  const [expandedRowId, setExpandedRowId] = useState(null);

  const userDetails = (phone) => {
    const targetUser = users?.find((user) => user.phone === phone);
    return {
      name: targetUser?.name || 'no',
      email: targetUser?.email || 'no',
      registerDate: targetUser?.registar_date || 'no'
    };
  };

  const paymentDetails = (phone) => {
    const targetUser = allPayments?.find((user) => user.phone === phone);
    return {
      amount: targetUser?.amount || '',
      year: targetUser?.year || '',
      buyDate: targetUser?.date || '',
    };
  };



  const toggleRowDetails = (id) => {
    // If clicking the same row, collapse it; otherwise expand the new row
    setExpandedRowId((prevId) => (prevId === id ? null : id));
  };

  const typeCounts = useMemo(() => {
    if (!appitemsuse) return {};

    return appitemsuse.reduce((acc, item) => {
      if (item.type) {
        acc[item.type] = (acc[item.type] || 0) + 1;
      }
      return acc;
    }, {});
  }, [appitemsuse]);

  const toIST = (dateString) => {
    if (!dateString) return 'Loading...';
    const date = new Date(dateString);
    if (isNaN(date)) return dateString;

    const istDate = new Date(date.getTime() + (5.5 * 60 * 60 * 1000));
    return istDate.toLocaleString('en-IN', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    });
  };

  if (loading) {
    return <Loading />;
  }

  const totalItems = appitemsuse ? appitemsuse.length : 0;

  const totalPages =
    itemsPerPage === 'all'
      ? 1
      : Math.ceil(totalItems / Number(itemsPerPage));

  const startIndex =
    itemsPerPage === 'all'
      ? 0
      : (currentPage - 1) * Number(itemsPerPage);

  const displayedItems =
    itemsPerPage === 'all'
      ? appitemsuse || []
      : (appitemsuse || []).slice(
        startIndex,
        startIndex + Number(itemsPerPage)
      );

  const handleItemsPerPage = (e) => {
    setItemsPerPage(e.target.value);
    setCurrentPage(1);
  };

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
    }
  };

  return (
    <div className="all-user-data-container">
      <div className="user-data-content-wrapper">
        <div
          className="stats-overview-grid"
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))',
            gap: '15px',
            marginBottom: '25px',
            marginTop: '15px'
          }}
        >
          <div
            className="stat-summary-card"
            style={{
              background: '#eef2ff',
              borderLeft: '5px solid #4f46e5',
              padding: '15px',
              borderRadius: '8px',
              boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
            }}
          >
            <h4
              style={{
                margin: '0 0 5px 0',
                color: '#4f46e5',
                fontSize: '14px',
                textTransform: 'uppercase'
              }}
            >
              Total Hits
            </h4>
            <p
              style={{
                margin: 0,
                fontSize: '24px',
                fontWeight: 'bold',
                color: '#1f2937'
              }}
            >
              {totalItems}
            </p>
          </div>

          {Object.keys(typeCounts).map((typeName) => (
            <div
              key={typeName}
              className="stat-summary-card"
              style={{
                background: '#fff',
                border: '1px solid #e5e7eb',
                borderLeft: '5px solid #10b981',
                padding: '15px',
                borderRadius: '8px',
                boxShadow: '0 2px 4px rgba(0,0,0,0.05)'
              }}
            >
              <h4
                style={{
                  margin: '0 0 5px 0',
                  color: '#4b5563',
                  fontSize: '14px',
                  textTransform: 'capitalize'
                }}
              >
                {typeName.replace(/([A-Z])/g, ' $1')}
              </h4>
              <p
                style={{
                  margin: 0,
                  fontSize: '24px',
                  fontWeight: 'bold',
                  color: '#111827'
                }}
              >
                {typeCounts[typeName]}
              </p>
            </div>
          ))}
        </div>

        <div className="user-data-card">
          <h2 className="user-data-title">All Items Information</h2>

          <div className="items-per-page-container">
            <div className="items-per-page">
              <label htmlFor="itemsPerPage">Show:</label>
              <select
                id="itemsPerPage"
                value={itemsPerPage}
                onChange={handleItemsPerPage}
              >
                <option value="10">10</option>
                <option value="25">25</option>
                <option value="50">50</option>
                <option value="100">100</option>
                <option value="all">All</option>
              </select>
              <span>items</span>
            </div>
          </div>

          <div className="table-responsive">
            <table className="user-data-table">
              <thead>
                <tr>
                  <th>#</th>
                  <th>User Phone</th>
                  <th>Name</th>
                  <th>Type</th>
                  <th>Date</th>
                  <th>Id</th>
                </tr>
              </thead>

              <tbody>
                {displayedItems.length > 0 ? (
                  displayedItems.map((item, index) => {
                    const rowId = item.id || index;
                    const isExpanded = expandedRowId === rowId;
                    const details = userDetails(item.userPhone);
                    const Paymentdetails = paymentDetails(item.userPhone);

                    return (
                      <React.Fragment key={rowId}>
                        {/* Clickable Row */}
                        <tr
                          onClick={() => toggleRowDetails(rowId)}
                          style={{
                            cursor: 'pointer',
                            backgroundColor: isExpanded
                              ? '#f9fafb'
                              : 'transparent'
                          }}
                        >
                          <td>{startIndex + index + 1}</td>
                          <td>{item.userPhone || ''}</td>
                          <td>{item.name || 'Loading...'}</td>
                          <td>
                            <span className="type-badge">
                              {item.type || 'Loading...'}
                            </span>
                          </td>
                          <td>{toIST(item.date)}</td>
                          <td>
                            {item.id || 'Loading...'}{' '}
                            <span style={{ fontSize: '11px', color: '#6b7280' }}>
                              {isExpanded ? '▲' : '▼'}
                            </span>
                          </td>
                        </tr>

                        {/* Collapsible Details Row */}
                        {isExpanded && (
                          <tr>
                            <td
                              colSpan="6"
                              style={{
                                backgroundColor: '#f0fdf4',
                                padding: '15px 20px',
                                borderLeft: '4px solid #10b981'
                              }}
                            >
                              <div
                                style={{
                                  float: 'left',
                                  gap: '20px',
                                  flexWrap: 'wrap'
                                }}
                              >
                                <p style={{ margin: 0 }}>
                                  <strong>Name:</strong> {details.name}
                                </p>
                                <p style={{ margin: '5px' }}>
                                  <strong>Email:</strong> {details.email}
                                </p>
                                <p style={{ margin: 0 }}>
                                  <strong>Register Date:</strong>{' '}
                                  {toIST(details.registerDate)}
                                </p> 
                                <hr></hr>
                                <p style={{ margin: 0 }}>
                                  <strong>Amount Pay:</strong> {Paymentdetails.amount}
                                </p>
                                <p style={{ margin: 0 }}>
                                  <strong>Purchase for:</strong> {Paymentdetails.year} year
                                </p>
                                <p style={{ margin: 0 }}>
                                  <strong>Buy Date:</strong>
                                  {toIST(Paymentdetails.buyDate)}
                                </p>
                              </div>
                            </td>
                          </tr>
                        )}
                      </React.Fragment>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="6" className="no-data-message">
                      No items found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {itemsPerPage !== 'all' && totalItems > 0 && (
            <div className="user-pagination">
              <button
                onClick={() => goToPage(currentPage - 1)}
                disabled={currentPage === 1}
              >
                ← Previous
              </button>

              <span>
                Page <strong>{currentPage}</strong> of{' '}
                <strong>{totalPages}</strong>
              </span>

              <button
                onClick={() => goToPage(currentPage + 1)}
                disabled={currentPage === totalPages}
              >
                Next →
              </button>
            </div>
          )}

          <div className="user-data-stats">
            <p>
              Showing{' '}
              <strong>
                {totalItems === 0 ? 0 : startIndex + 1}
              </strong>{' '}
              to{' '}
              <strong>
                {Math.min(
                  startIndex + displayedItems.length,
                  totalItems
                )}
              </strong>{' '}
              of <strong>{totalItems}</strong> records
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppItemsUse;